import React from 'react'

import ContactForm from '../ContactFrom/ContactForm'
import icon1 from '../../images/icon/call-calling.svg'
import icon2 from '../../images/icon/icon-sms.svg'


const ContactSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className="contact pt-85">
                <div className="container">
                    <div className="row pb-130 mt-none-30">
                        <div className="col-lg-8 mt-30">
                            <div className="cs-contact-wrap cs-contact-form cd-contact-form item-contact_form">
                                <h2 className="xb-title">Send us a message</h2>
                                <p className="xb-content">Give us a chance to serve and bring magic to your brand.</p>
                                <ContactForm />
                            </div>
                        </div>
                        <div className="col-lg-4 mt-30">
                            <div className="item-contact_info">
                                <div className="xb-item--inner">
                                    <div className="xb-item--top">
                                        <h3 className="xb-item--title">Contact Info</h3>
                                        <span className="xb-item--hotline"><img src={icon1} alt="" /> +91 7806967605</span>
                                        <span className="xb-item--email"><img src={icon2} alt="" /> support@uniflame.org</span>
                                        <ul className="social_icons_block list-unstyled ul_li">
                                            
                                                                 <li>
  <a 
    onClick={ClickHandler} 
    href="https://www.linkedin.com/company/uniflames/" 
    aria-label="Linkedin"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
</li> </ul>

                                    </div>
                                   <div className="contact-info_widget">
    <h3 className="xb-title">Chennai Office </h3>
    <span className="xb-location">
        1402 2nd floor ,Gold colony 4th street<br />
        Mogappair  Chennai – 600037
    </span>
</div>

<div className="contact-info_widget">
    <h3 className="xb-title">London(head office)</h3>

</div>




                                    <hr className="breack-line" />
                                    <div className="contact-info_widget">
                                        <h3 className="xb-title">our office open time</h3>
                                        <span className="xb-location">Mon - Sat : 8.00-5.00 <br /> Sunday : Closed</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gmap_canvas bg-light">
                <iframe title="map" 
  src="https://maps.google.com/maps?q=Chennai&t=&z=13&ie=UTF8&iwloc=&output=embed">
</iframe>

            </div>
        </div>
    )
}

export default ContactSection;
